import React from 'react';
import loadable from '@loadable/component';
// eslint-disable-next-line
import type { FilterProps } from './filter';

const LoadableFilter = loadable(
  () => import(/* webpackChunkName: "category" */ './filter')
);

export const HorizontalFilter = loadable(
  () => import(/* webpackChunkName: "category" */ './horizontal-filter')
);

type LoaderProps = FilterProps & {
  className?: string;
};

const Loader: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<LoaderProps>>
> = props => (
  <div className={props.className}>
    <LoadableFilter {...props} />
  </div>
);

export default Loader;
